import React from "react";
import { Box, Tooltip, IconButton, Divider, Typography } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import awsIcon from "../../assets/logo/aws.png";
import { useNavigate } from "react-router-dom";

const SidebarNavigation = ({ selectedTab }) => {
  const navigate = useNavigate();

  const sidebarItems = [
    {
      id: "calendar",
      title: "Calendar View",
      icon: <CalendarMonthIcon sx={{ fontSize: 20 }} />,
      label: "CALENDAR",
    },
    {
      id: "aws",
      title: "AWS Alerts",
      icon: (
        <Box
          component="img"
          src={awsIcon}
          alt="AWS"
          sx={{
            width: 23,
            height: 14,
            filter: "brightness(0) invert(1)",
          }}
        />
      ),
      label: "AWS ALERTS",
    },
    // {
    //   id: "history",
    //   title: "History",
    //   icon: <ArchiveOutlinedIcon sx={{ fontSize: 20 }} />,
    //   label: "HISTORY",
    // },
  ];

  return (
    <Box
      className="d-flex flex-column align-items-center bg-black text-white position-fixed start-0 z-1"
      sx={{
        width: "72px",
        height: "100%",
        top: -10,
        py: 1,
      }}
    >
      <Box sx={{ height: "60px" }} />

      {sidebarItems.map((item) => (
        <Box
          key={item.id}
          className="text-center mb-3 d-flex flex-column align-items-center justify-content-center position-relative px-1 w-100"
          sx={{
            cursor: "pointer",
            height: "60px",
            backgroundColor:
              selectedTab === item.id ? "#3a3a3a" : "transparent",
            "&::before":
              selectedTab === item.id
                ? {
                  content: '""',
                  position: "absolute",
                  right: "2px",
                  top: 0,
                  bottom: 0,
                  width: "3px",
                  backgroundColor: "#fff",
                  borderRadius: "6px",
                }
                : {},
            "&:hover": {
              backgroundColor: selectedTab === item.id ? "#3a3a3a" : "#222",
            },
          }}
          onClick={() => navigate(`/${item.id}`)}
        >
          <IconButton
            disableRipple
            className="d-flex align-items-center justify-content-center rounded-circle p-0"
            sx={{
              width: 30,
              height: 30,
              color: "#fff",
            }}
          >
            {item.icon}
          </IconButton>

          <Typography
            variant="caption"
            className="text-center"
            sx={{
              fontSize: "9px",
              color: "#ccc",
              marginTop: "2px",
              lineHeight: 1.3,
            }}
          >
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default SidebarNavigation;